import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 620px;
`;
export const HeaderBar = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 80px;
`;

export const ContentBlock = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  justify-items: center;
  align-items: start;
  width: 100%;
  height: auto;
  padding-top: 40px;
  gap: 40px;

  ${(p) => p.theme.breakpoints.up('md')} {
    grid-template-columns: 1fr 3fr;
  }

  ${(p) => p.theme.breakpoints.down('md')} {
    padding-top: 0;
    justify-content: center;
  }
`;

export const SideBar = styled.div`
  height: 100%;
  align-self: start;
  position: sticky;
  top: 70px;
  width: 300px;

  ${(p) => p.theme.breakpoints.down('mobile')} {
    width: calc(100% - 25px);
    max-width: none;
  }
`;
